import { render, staticRenderFns } from "./SplashScreenVideoUploadForm.vue?vue&type=template&id=c6c08dfc&scoped=true"
import script from "./SplashScreenVideoUploadForm.vue?vue&type=script&lang=js"
export * from "./SplashScreenVideoUploadForm.vue?vue&type=script&lang=js"
import style0 from "./SplashScreenVideoUploadForm.vue?vue&type=style&index=0&id=c6c08dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c08dfc",
  null
  
)

export default component.exports